import { render } from "./CardDesignPanel.vue?vue&type=template&id=56b4d508&scoped=true"
import script from "./CardDesignPanel.vue?vue&type=script&lang=js"
export * from "./CardDesignPanel.vue?vue&type=script&lang=js"

import "./CardDesignPanel.vue?vue&type=style&index=0&id=56b4d508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b4d508"]])

export default __exports__